import { render, staticRenderFns } from "./Profile.ChangePassword.vue?vue&type=template&id=0c75d70e&scoped=true"
import script from "./Profile.ChangePassword.vue?vue&type=script&lang=js"
export * from "./Profile.ChangePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c75d70e",
  null
  
)

export default component.exports